export enum OrganizationMemberRole {
    SUPERADMIN = 'SUPERADMIN',
    ADMIN = 'ADMIN',
    MEMBER = 'MEMBER',
}

export enum OrganizationMemberStatus {
    PENDING = 'PENDING',
    EXPIRED = 'EXPIRED',
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE',
}

export enum OrganizationMemberMembershipType {
    MANAGED = 'MANAGED',
    UNMANAGED = 'UNMANAGED',
}

export interface OrganizationMemberDto {
    id: string;
    email: string;
    displayName: string;
    role: OrganizationMemberRole;
    status: OrganizationMemberStatus;
    membershipType: OrganizationMemberMembershipType;
}

export interface UpdateOrganizationMemberRoleRequestDto {
    role: OrganizationMemberRole;
}

export interface OrganizationMemberPage {
    content: OrganizationMemberDto[];
    page: number;
    size: number;
    totalElements: number;
    totalPages: number;
}
